module.exports = __webpack_public_path__ + "static/media/2.ef130c56.svg";